// ============================================================
// Cetak ulang SPK — autocomplete + daftar SPK
// ============================================================

import Alpine from 'alpinejs';

Alpine.data('spkReprint', () => ({
  query: '',
  results: [],
  list: [],
  loading: false,
  listLoading: false,
  showDropdown: false,
  searched: false,
  error: '',
  highlightIdx: 0,
  debounceTimer: null,

  init() {
    this.fetchList();
  },

  minLength() {
    const q = this.query.trim();
    return /^\d+$/.test(q) ? 1 : 2;
  },

  onInput() {
    clearTimeout(this.debounceTimer);
    this.error = '';
    const q = this.query.trim();

    if (q.length < this.minLength()) {
      this.results = [];
      this.showDropdown = false;
      this.searched = false;
      this.highlightIdx = 0;
      this.debounceTimer = setTimeout(() => this.fetchList(), 200);
      return;
    }

    this.debounceTimer = setTimeout(() => {
      this.fetchSuggestions();
      this.fetchList();
    }, 200);
  },

  async fetchSuggestions() {
    const q = this.query.trim();
    if (q.length < this.minLength()) return;

    this.loading = true;
    this.error = '';

    try {
      const { data } = await axios.get('/api/v1/kasir/spk/suggest', { params: { q } });
      this.results = data.data || [];
      this.showDropdown = this.results.length > 0;
      this.searched = true;
      this.highlightIdx = 0;
    } catch (e) {
      this.results = [];
      this.showDropdown = false;
      this.searched = true;
      this.error = e.response?.data?.message || 'Gagal mencari SPK.';
    } finally {
      this.loading = false;
    }
  },

  async fetchList() {
    const q = this.query.trim();
    if (q.length > 0 && q.length < this.minLength()) {
      return;
    }

    this.listLoading = true;
    try {
      const { data } = await axios.get('/api/v1/kasir/spk/reprint-list', {
        params: { q, limit: 50 },
      });
      this.list = data.data || [];
    } catch (e) {
      this.list = [];
      if (!this.error) {
        this.error = e.response?.data?.message || 'Gagal memuat daftar SPK.';
      }
    } finally {
      this.listLoading = false;
    }
  },

  selectItem(item) {
    if (item?.preview_url) {
      window.location.href = item.preview_url;
    }
  },

  pickFirst() {
    if (this.results.length) {
      this.selectItem(this.results[this.highlightIdx] || this.results[0]);
    }
  },

  highlightNext() {
    if (!this.results.length) return;
    this.highlightIdx = (this.highlightIdx + 1) % this.results.length;
  },

  highlightPrev() {
    if (!this.results.length) return;
    this.highlightIdx = (this.highlightIdx - 1 + this.results.length) % this.results.length;
  },
}));
